import React from 'react';
import { motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
interface TrustScoreProps {
  score: number; // 0 to 100
  size?: number;
  strokeWidth?: number;
  className?: string;
}
export function TrustScore({
  score,
  size = 64,
  strokeWidth = 6,
  className
}: TrustScoreProps) {
  const clampedScore = Math.min(Math.max(score, 0), 100);
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDashoffset = circumference - clampedScore / 100 * circumference;
  // Determine color based on score
  let colorClass = 'text-brand-success';
  if (clampedScore < 50) colorClass = 'text-brand-danger';else if (clampedScore < 80) colorClass = 'text-brand-warning';
  return <div className={twMerge('relative inline-flex items-center justify-center', className)} style={{
    width: size,
    height: size
  }} data-id="element-68">
      {/* Background Circle */}
      <svg className="transform -rotate-90 w-full h-full" data-id="element-69">
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="currentColor" strokeWidth={strokeWidth} fill="transparent" className="text-gray-100" data-id="element-70" />
        {/* Progress Circle */}
        <motion.circle cx={size / 2} cy={size / 2} r={radius} stroke="currentColor" strokeWidth={strokeWidth} fill="transparent" strokeDasharray={circumference} initial={{
        strokeDashoffset: circumference
      }} animate={{
        strokeDashoffset
      }} transition={{
        duration: 1.5,
        ease: 'easeOut'
      }} className={colorClass} strokeLinecap="round" data-id="element-71" />
      </svg>
      {/* Score Text */}
      <div className="absolute flex flex-col items-center justify-center" data-id="element-72">
        <span className="text-sm font-bold text-text-primary leading-none" data-id="element-73">
          {clampedScore}
        </span>
      </div>
    </div>;
}